import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5149dce4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "bg-white position-relative shadow heading px-lg-5 p-3 py-lg-4 mb-lg-5 mb-4 gx-0"
}
const _hoisted_5 = { class: "pe-lg-4" }
const _hoisted_6 = { class: "fw-bold mb-4 pe-5 pe-lg-0" }
const _hoisted_7 = {
  key: 0,
  class: "ms-4 badge bg-green"
}
const _hoisted_8 = { class: "row d-flex align-content-center justify-content-center" }
const _hoisted_9 = { class: "fw-bold fs-lg-6 fs-8 col-lg-6 text-center text-lg-start mb-3 mb-lg-0" }
const _hoisted_10 = { class: "fs-5" }
const _hoisted_11 = { class: "d-flex justify-content-lg-end justify-content-center col-lg-6" }
const _hoisted_12 = {
  key: 2,
  class: "tab-header d-flex justify-content-center align-items-center m-0 mb-4 mb-lg-5 p-0"
}
const _hoisted_13 = {
  key: 0,
  class: "text-decoration-none fw-bold position-relative me-2 link-talk"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caret text-center position-absolute" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down" })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caret2 text-center position-absolute" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down" })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caret text-center position-absolute" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down" })
], -1))

import { translate } from '@/languages/i18n'
import Submenu from '@/components/submenu/index.vue'
import { useRoute, useRouter } from 'vue-router'
import { onMounted, computed, ref, watch } from 'vue'
import groupsService from '@/services/groups.service'
import Button from '@/components/button/index.vue'
import DeleteGroupModal from '@/views/user/groups/components/DeleteGroupModal.vue'
import EditGroupModal from '@/views/user/groups/components/EditGroupModal.vue'
import LeaveInvitationGroupModal from '@/views/user/groups/components/LeaveInvitationGroupModal.vue'
import { useStore } from 'vuex'
import { numberWithCommas } from '@/components/comma-break/index.ts'
import { GROUPS_STORE } from '@/store/constants'
import TargetTag from '@/components/target-tag/index.vue'
//Toast
import 'vue-toastification/dist/index.css'
import { useToast } from 'vue-toastification'
import ErrorToast from '@/components/toast-error/index404.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const toast = useToast()

const store = useStore()
const detailGroup = computed(() => store.getters[GROUPS_STORE.GETTERS.DETAIL_GROUPS])
const loadingDetail = computed(() => store.getters[GROUPS_STORE.GETTERS.LOADING_DETAIL])
const preventLoading = computed(() => store.getters[GROUPS_STORE.GETTERS.PREVENT_LOADING_AGAIN])

const menu = [
  {
    title: translate('editGroup'),
  },
  {
    title: translate('deleteGroup'),
  },
]
// 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN70 (Ph2-R20220930)
const loadingSubmit = ref(false)
// 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN70 (Ph2-R20220930)
const route = useRoute()
const router = useRouter()
const infoGroup = ref({
  id: '',
  name: '',
})
onMounted(() => {
  if (!preventLoading.value) {
    store.dispatch(GROUPS_STORE.ACTIONS.SET_DETAIL_GROUPS, { group_id: route?.params?.group_id, prevent_loading: false })
  } else {
    store.dispatch(GROUPS_STORE.ACTIONS.SET_DETAIL_GROUPS, { group_id: route?.params?.group_id, prevent_loading: true })
  }
})

watch(
  () => route.path,
  (newVal) => {
    if (!['users', 'talk_rooms'].includes(newVal?.split('/')[6])) store.dispatch(GROUPS_STORE.ACTIONS.SET_PREVENT_LOADING_AGAIN, false)
  }
)

const group_id = ref<string | number>('')
const group_name = ref<string>('')

const ChangeEdit = (id: string | number, name: string) => {
  group_id.value = id
  group_name.value = name
}

const JoinGroup = async (id: string | number) => {
  // 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN70 (Ph2-R20220930)
  loadingSubmit.value = true
  // 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN70 (Ph2-R20220930)

  try {
    const response = await groupsService.joinGroupApi(id)
    if (response?.status === 200) {
      store.dispatch(GROUPS_STORE.ACTIONS.JOIN_GROUP, id)
      store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_USER_GROUP, route?.params?.group_id)
    } else if (response?.status !== 200) {
      // 2022/12/19 CW-PhuongTT Fix for UAT#5644: SN70 (Ph2-R20221222)
      toast.error({
        component: ErrorToast,
        props: {
          messageCode: 'serverError4',
        },
      })
    }
  } catch (error) {
    console.log(error)
  }
  // 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN70 (Ph2-R20220930)
  loadingSubmit.value = false
  // 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN70 (Ph2-R20220930)
}
const ExitGroup = async (id: string | number) => {
  // 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN70 (Ph2-R20220930)
  loadingSubmit.value = true
  // 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN70 (Ph2-R20220930)

  try {
    const response = await groupsService.exitGroupApi(id)
    if (response?.status === 200) {
      store.dispatch(GROUPS_STORE.ACTIONS.EXIT_GROUP, id)
      store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_USER_GROUP, route?.params?.group_id)
    } else if (response?.status !== 200) {
      // 2022/12/19 CW-PhuongTT Fix for UAT#5644: SN70 (Ph2-R20221222)
      toast.error({
        component: ErrorToast,
        props: {
          messageCode: 'serverError3',
        },
      })
    }
  } catch (error) {
    console.log(error)
  }
  // 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN70 (Ph2-R20220930)
  loadingSubmit.value = false
  // 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN70 (Ph2-R20220930)
}

const TransitTalkroom = () => {
  router.push(`/${route.path.split('/')[1]}/communities/${route.params.id}/groups/${route.params.group_id}/talk_rooms`)
  store.dispatch(GROUPS_STORE.ACTIONS.SET_PREVENT_LOADING_AGAIN, true)
}

const TransitUsers = () => {
  store.dispatch(GROUPS_STORE.ACTIONS.SET_PREVENT_LOADING_AGAIN, true)
}

watch(
  () => detailGroup.value,
  () => {
    if (
      detailGroup?.value?.status === 3 &&
      !detailGroup?.value?.invitation_group &&
      (route.path === `/${route.path.split('/')[1]}/communities/${route.params?.id}/groups/${route.params?.group_id}/talk_rooms` ||
        route.path === `/${route.path.split('/')[1]}/communities/${route.params?.id}/groups/${route.params?.group_id}/talk_rooms/${route.params.talkroom_id}`)
    )
      router.push(`/${route.path.split('/')[1]}/communities/${route.params?.id}/groups/${route.params?.group_id}/users`)
    if (detailGroup?.value?.status === 3 && detailGroup?.value?.invitation_group) {
      router.push(`/${route.path.split('/')[1]}/communities/${route.params?.id}/groups`)
    }
  },
  {
    deep: true,
  }
)

const ShowModalEdit = () => {
  infoGroup.value = {
    id: detailGroup.value?.id,
    name: detailGroup.value?.name,
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(loadingDetail))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (!_unref(loadingDetail))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(detailGroup)?.name) + " ", 1),
              (_unref(detailGroup)?.invitation_group === true)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(translate)('inviteOnlyGroup')), 1))
                : _createCommentVNode("", true)
            ]),
            (_unref(detailGroup)?.status === 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "sub-container position-absolute",
                  onClick: ShowModalEdit
                }, [
                  _createVNode(Submenu, {
                    dataBs: [
            ['modal', '#editGroupDefault'],
            ['modal', '#deleteGroupAlumni'],
          ],
                    menu: menu
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(TargetTag, {
              data: _unref(detailGroup)?.information,
              class: "information mb-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.TransitSO65(_ctx.item?.id)))
            }, null, 8, ["data"]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(_unref(translate)('participantGroup')) + " : ", 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(numberWithCommas)(Number(_unref(detailGroup)?.members))), 1),
                _createElementVNode("span", null, _toDisplayString(_unref(translate)('name')), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                ([3].includes(_unref(detailGroup)?.status) && !_unref(detailGroup)?.invitation_group)
                  ? (_openBlock(), _createBlock(Button, {
                      key: 0,
                      disabled: loadingSubmit.value,
                      title: _unref(translate)('join'),
                      type: 'secondary',
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (JoinGroup(_unref(detailGroup)?.id))),
                      size: 'small',
                      className: 'fw-bold'
                    }, null, 8, ["disabled", "title"]))
                  : _createCommentVNode("", true),
                ([2].includes(_unref(detailGroup)?.status))
                  ? (_openBlock(), _createBlock(Button, {
                      key: 1,
                      disabled: loadingSubmit.value,
                      title: _unref(translate)('exit'),
                      type: 'secondary',
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(detailGroup)?.invitation_group ? ChangeEdit(_unref(detailGroup)?.id, _unref(detailGroup)?.name) : ExitGroup(_unref(detailGroup)?.id))),
                      dataBsToggle: _unref(detailGroup)?.invitation_group ? 'modal' : '',
                      dataBsTarget: _unref(detailGroup)?.invitation_group ? '#leaveInvitationGroup' : '',
                      size: 'small',
                      className: 'fw-bold'
                    }, null, 8, ["disabled", "title", "dataBsToggle", "dataBsTarget"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(EditGroupModal, {
      groupId: infoGroup.value?.id
    }, null, 8, ["groupId"]),
    _createVNode(DeleteGroupModal, {
      groupId: infoGroup.value?.id,
      groupName: infoGroup.value?.name
    }, null, 8, ["groupId", "groupName"]),
    (!_unref(loadingDetail))
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_unref(detailGroup)?.status === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(translate)('talkRoom')), 1))
            : _createCommentVNode("", true),
          (
        _unref(route).path !== `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params.id}/groups/${_unref(route).params.group_id}/talk_rooms/${_unref(route).params.talkroom_id}` &&
        [1, 2].includes(_unref(detailGroup)?.status)
      )
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params.id}/groups/${_unref(route).params.group_id}/talk_rooms`,
                class: "text-decoration-none fw-bold position-relative me-2 link-talk"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)('talkRoom')) + " ", 1),
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          (_unref(route).path === `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params.id}/groups/${_unref(route).params.group_id}/talk_rooms/${_unref(route).params.talkroom_id}`)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "text-decoration-none fw-bold position-relative me-2 link-talk fetch-router cursor-pointer",
                onClick: TransitTalkroom
              }, [
                _createTextVNode(_toDisplayString(_unref(translate)('talkRoom')) + " ", 1),
                _hoisted_15
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params.id}/groups/${_unref(route).params.group_id}/users`,
            class: "text-decoration-none fw-bold position-relative link-user",
            onClick: TransitUsers
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate)('participantGroup')) + " ", 1),
              _hoisted_16
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(LeaveInvitationGroupModal, {
      name: group_name.value,
      displaySuccessModal: false,
      onLeaveInvitationGroup: _cache[3] || (_cache[3] = ($event: any) => (ExitGroup(group_id.value)))
    }, null, 8, ["name"])
  ], 64))
}
}

})